<template>
  <div class="column window-height">
    <ApplicationHeader />
    <QLayout view="lHh lpr lFf" container class="col-grow app-layout">
      <ProgressHeader />
      <router-view />
    </QLayout>
  </div>
</template>

<script>
import { QLayout } from 'quasar';

export default {
  name: 'MainLayout',
  components: {
    QLayout,
    ProgressHeader: () => import('../../../widgets/progress-header'),
    ApplicationHeader: () => import('../../../widgets/application-header')
  }
};
</script>
